__turbopack_context__.v({
  "button": "WhiteBoxGeneral-module-scss-module__iLDMeW__button",
  "image": "WhiteBoxGeneral-module-scss-module__iLDMeW__image",
  "imageBox": "WhiteBoxGeneral-module-scss-module__iLDMeW__imageBox",
  "item": "WhiteBoxGeneral-module-scss-module__iLDMeW__item",
  "item_1": "WhiteBoxGeneral-module-scss-module__iLDMeW__item_1",
  "item_2": "WhiteBoxGeneral-module-scss-module__iLDMeW__item_2",
  "item_3": "WhiteBoxGeneral-module-scss-module__iLDMeW__item_3",
  "item_4": "WhiteBoxGeneral-module-scss-module__iLDMeW__item_4",
  "item_5": "WhiteBoxGeneral-module-scss-module__iLDMeW__item_5",
  "item_6": "WhiteBoxGeneral-module-scss-module__iLDMeW__item_6",
  "item_7": "WhiteBoxGeneral-module-scss-module__iLDMeW__item_7",
  "item_8": "WhiteBoxGeneral-module-scss-module__iLDMeW__item_8",
  "list": "WhiteBoxGeneral-module-scss-module__iLDMeW__list",
  "svgLineBox": "WhiteBoxGeneral-module-scss-module__iLDMeW__svgLineBox",
  "title": "WhiteBoxGeneral-module-scss-module__iLDMeW__title",
  "wrapper": "WhiteBoxGeneral-module-scss-module__iLDMeW__wrapper",
});
